import { Button, Card, CardContent, CardMedia, MobileStepper, Typography } from '@mui/material';
import React from 'react';
import Makaz from '../../../Assets/Images/shops/nya/Makaz1.jpg';
import { useTheme } from '@mui/material/styles';
// import catalogueData from '../../BuyAndSell/data/catalogueData';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import { Box } from '@mui/system';
import shopsData from '../../TheMall/data/shopsData';
import { NavigateBefore, NavigateNext } from '@mui/icons-material';

export default function LPBillBoard() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = shopsData.length;
  const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Gene20Box sx={{ flexGrow: 1, position: 'relative' }}>
      <Gene20Box sx={{ display: { sm: 'flex' }, justifyContent: 'center', alignItems: 'center' }}>
        <Gene20Box
          align="center"
          sx={
            {
              // position: "absolute",
              // justifyContent: 'center',
              // alignItems: 'center',
              // display: 'flex',
              // width: '100%',
              // height: '100%',
              // zIndex: 1,
            }
          }
        >
          <Typography
            variant="h4"
            // color="secondary"
            align="left"
            sx={{
              color: 'white',
              display: 'flex',
              alignItems: 'left',
              height: 50,
              pl: 2,
            }}
          >
            {shopsData[activeStep].name}
          </Typography>
          <AutoPlaySwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
          >
            {shopsData.map((step, index) => (
              <div key={step.name}>
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box
                    component="img"
                    sx={{
                      height: { xs: '40vh', sm: '60vh' },
                      display: 'block',
                      maxWidth: { xs: '100%', sm: '60vh' },
                      overflow: 'hidden',
                      // opacity: '0.5',
                      width: '100%',
                      borderRadius: '30%',
                    }}
                    src={step.image}
                    alt={step.name}
                  />
                ) : null}
              </div>
            ))}
          </AutoPlaySwipeableViews>
        </Gene20Box>

        <Typography> get it only for {shopsData[activeStep].price}</Typography>
      </Gene20Box>

      <MobileStepper
        sx={{ background: 'transparent' }}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button size="large" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            <NavigateNext />
          </Button>
        }
        backButton={
          <Button size="large" onClick={handleBack} disabled={activeStep === 0}>
            <NavigateBefore />
          </Button>
        }
      />
    </Gene20Box>
  );
}
